import { render, staticRenderFns } from "./MoveSectionModal.vue?vue&type=template&id=7a125e85&"
import script from "./MoveSectionModal.vue?vue&type=script&lang=js&"
export * from "./MoveSectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports